import * as Yup from 'yup';
import { useState } from 'react';
// @mui
import { Stack, IconButton, InputAdornment } from '@mui/material';
import { LoadingButton } from '@mui/lab';
// hooks
import useAuth from '../../../hooks/useAuth';
// components
import Iconify from '../../../components/Iconify';
import { FormikPasswordView, FormikTextView } from 'src/basic-components/formik-inputs';
import { Form, Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import T from 'src/basic-components/text';
import { useNotify } from 'src/hooks/use-notify';

// ----------------------------------------------------------------------

export default function RegisterForm() {
  const notify = useNotify();
  const { register } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();
  const [showPassword, setShowPassword] = useState(false);

  const onSubmit = async (data) => {
    setIsLoading(true);
    register(data.userName, data.password, data.firstName, data.lastName)
      .then((res) => notify.success(t(res)))
      .catch((err) => notify.error(t(err)))
      .finally(() => setIsLoading(false));
  };

  const validationSchema = Yup.object({
    userName: Yup.string()
      .matches(/^(\+98|0098|98|0)?9\d{9}$/, t('invalid-mobile-number'))
      .required(t('required')),
    firstName: Yup.string().required(t('required')),
    lastName: Yup.string().required(t('required')),
    password: Yup.string().required(t('required')),
  });
  return (
    <Stack spacing={3}>
      <Formik
        initialValues={{
          userName: '',
          password: '',
          firstName: '',
          lastName: '',
        }}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {(formik) => (
          <Form>
            <Stack direction="column" spacing={2}>
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                <FormikTextView name="firstName" label="firstname" formik={formik} />
                <FormikTextView name="lastName" label="lastname" formik={formik} />
              </Stack>
              <FormikTextView name="userName" label="username" formik={formik} />
              <FormikPasswordView
                name="password"
                label="password"
                formik={formik}
                type={showPassword ? 'text' : 'password'}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton edge="end" onClick={() => setShowPassword(!showPassword)}>
                        <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <LoadingButton fullWidth size="large" type="submit" variant="contained" loading={isLoading}>
                <T>register</T>
              </LoadingButton>
            </Stack>
          </Form>
        )}
      </Formik>
    </Stack>
  );
}
